export const freeCollateralDescription =
  'Balance less margin reserved for open positions.';

export const availableCollateralDescription =
  'Balance less margin reserved for open positions and open orders.';

export const balanceDescription =
  'Total Account Value (includes unrealized P&L).';

export const leverageDescription =
  'Total positions (notional) divided by balance.';

export const marginRationDescription =
  'Maintenance margin divided by balance. When your margin ratio reaches 100% your positions will be liquidated.';

export const ADLDescription = 'Tracks ADL queue position.';
